var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 13,
    fill: "#EFF0EF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8269 10.0416C14.7728 9.98236 14.7431 9.90348 14.744 9.82171C14.745 9.73993 14.7765 9.66178 14.832 9.60395C14.8875 9.54612 14.9624 9.51321 15.0408 9.51222C15.1192 9.51122 15.1949 9.54221 15.2517 9.59861L18.3044 12.7763C18.3595 12.8366 18.3902 12.9167 18.3902 13C18.3902 13.0833 18.3595 13.1633 18.3044 13.2236L15.2517 16.4014C15.1949 16.4578 15.1192 16.4888 15.0408 16.4878C14.9624 16.4868 14.8875 16.4539 14.832 16.396C14.7765 16.3382 14.745 16.2601 14.744 16.1783C14.7431 16.0965 14.7728 16.0176 14.8269 15.9584L17.3594 13.3177H7.91024C7.8299 13.3168 7.75316 13.2828 7.69684 13.223C7.64051 13.1633 7.6092 13.0827 7.60975 12.9989C7.60961 12.9577 7.61729 12.9169 7.63234 12.8789C7.6474 12.8408 7.66952 12.8062 7.69745 12.777C7.72538 12.7479 7.75857 12.7248 7.79509 12.7091C7.83161 12.6934 7.87074 12.6854 7.91024 12.6856H17.3594L14.8269 10.0416Z",
    fill: "#002A58"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.5cc98f1d6598e4c46d3854583c8992e6.svg";
export { ForwardRef as ReactComponent };